import type { DownlinkState } from 'client/workers/downlink/defs'
import create from 'zustand'

export const useDownlinkStore = create<DownlinkState>(() => ({
  status: 'idle',
  receivedMessagesCount: 0
}))
